<template>
	<div class="pending_wrap">
    <step-status :step="$route.meta.step" class="mt55"></step-status>

		<h1>Pending result</h1>
		<div class="letter">
			<p>Dear {{full_name}},</p>
			<p>Thank you for completing all of the steps in the application,interview,and training stages,this is the final total teacher profile check performed to ensure the requirements and qualifications of new teachers meet the overall standards prior to being added to the system. You will receive a feedback from our team within 3 business days.</p>
			<p>Best,<br/>HAWO Recruitment Team</p>

		</div>
		<div class="download">
			<ul class="clearfix">
				<li>
					<ac></ac>
				</li>
			</ul>
		</div>
	</div>
</template>
<script>
import ac from '@common/ac'
import mypage from '@common/mypage'
export default {
  props: {},
  data() {
    return {
      full_name: ''
    }
  },
  components: {
    ac,
    mypage
  },
  beforeRouteEnter: function(to, from, next) {
    next(vm => {
      vm.$http.get('/interview/getTutorProfile').then(d => {
        if ((d.data.code = '75000')) {
          vm.full_name = d.data.res.tutor.full_name
        }
			})
    })
  },
  created() {
    // let _this = this
    // this.$http.get('/boarding/checkTeacherStatus').then(d => {
    //   if (d.data.code == '75000') {
    //     let status = d.data.res.status
    //     switch (status) {
    //       case 'success':
    //         //后台已经上线
    //         this.$router.replace('/get_started')
    //         break

    //       case 'failed':
    //         this.$router.replace('/online_failed')
    //         break
    //     }
    //   }
    // })
  }
}
</script>
<style lang='less' scoped>
.pending_wrap {
  height: 752px;
  width: 1000px;
  margin: 0 auto;
  & > h1 {
    margin-top: 55px;
    font-size: 24px;
    font-weight: bolf;
    color: #ffb400;
  }
  div.letter {
    box-sizing: border-box;
    height: 384px;
    background: #f7f7f7;
    border-radius: 10px;
    margin-top: 30px;
    padding: 40px 30px;
    p {
      padding-bottom: 24px;
      line-height: 20px;
      color: #1e1e1e;
      a {
        color: #fd4c6e;
      }
    }
  }
  .download {
    position: fixed;
    top: 166px;
    right: 80px;
    & > ul {
      width: 75px;
      li {
        float: left;
        margin-top: 6px;
        background-color: #fff;
        border-radius: 5px;
        a {
          display: inline-block;
          box-sizing: border-box;
          vertical-align: middle;
          width: 75px;
          height: 75px;
          text-align: center;
          padding-top: 52px;
          background: url('~@img/donwload_icons.png') no-repeat
            center 10px;
          box-shadow: 0 0 2px 2px #ecebec;
          border-radius: 5px;
          &.mypage_icon {
            background-image: url('~@img/mypage_icons.png');
          }
          &:hover {
            border: 1px solid #fcc800;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// online_pending.vue?c570eaaa